/** 관제실 경광등 — 시스템 설정 UI / API */

export interface ControlRoomSirenSettings {
  /** true면 수동(관제사) 이벤트에도 관제실 경광·끄기 팝업 */
  include_manual_events: boolean;
}

export const DEFAULT_CONTROL_ROOM_SIREN_SETTINGS: ControlRoomSirenSettings = {
  include_manual_events: false,
};

export function mergeControlRoomSirenSettings(
  partial?: Partial<ControlRoomSirenSettings> | null
): ControlRoomSirenSettings {
  const p = partial || {};
  const d = DEFAULT_CONTROL_ROOM_SIREN_SETTINGS;
  const bool = (v: unknown, fallback: boolean) => {
    if (typeof v === 'boolean') return v;
    if (v === 'true' || v === '1') return true;
    if (v === 'false' || v === '0') return false;
    return fallback;
  };
  return {
    include_manual_events: bool(p.include_manual_events, d.include_manual_events),
  };
}
